import { Value } from "../../../models/Explorer";

/** Map from raw value → display label, keyed by filter name */
export type ValueLookup = Record<string, Map<string, string>>;

/**
 * Build a ValueLookup from the store's filter options and player filter options.
 */
export function buildValueLookup(
  filters: Record<string, { values: Value[] }> | null,
  playerValues?: Value[],
): ValueLookup {
  const lookup: ValueLookup = {};
  if (filters) {
    for (const [name, opt] of Object.entries(filters)) {
      const map = new Map<string, string>();
      for (const v of opt.values) {
        map.set(v.value, v.label);
      }
      lookup[name] = map;
    }
  }
  // Player filter values apply to any filter with player UUIDs
  if (playerValues && playerValues.length > 0) {
    const playerMap = new Map<string, string>();
    for (const v of playerValues) {
      playerMap.set(v.value, v.label);
    }
    // Merge player map into any filter that doesn't already have rich values
    // (player_id filters have empty values arrays in FilterResponse)
    if (filters) {
      for (const [name, opt] of Object.entries(filters)) {
        if (
          (opt as any).player_id &&
          (!opt.values || opt.values.length === 0)
        ) {
          lookup[name] = playerMap;
        }
      }
    }
  }
  return lookup;
}
